<template>
    <div class="page send-verify">

        <div class="title">
            输入验证码
            <div class="desc">
                验证码已发送至 {{tel}}
            </div>
        </div>

        <div class="content">
            <div class="cancel_otp_code_box">
                <div class="otpInputs">
                    <input v-enterfocus ref="otpInputs" type="number" v-model="code" @keydown.delete="changeCode">
                    <span class="code_list">{{code1}}</span>
                    <span class="code_list">{{code2}}</span>
                    <span class="code_list">{{code3}}</span>
                    <span class="code_list last_code_list">{{code4}}</span>
                </div>
                <p class="error_text" :class="{show: error}">Please try again</p>
            </div>
        </div>

        <div class="control">
            <div class="control-btn">
                <van-button :disabled="disabled" color="#D3172E" round size="small" @click="sendVerify()">
                    {{disabled && restTime > 0?`重新发送 ${restTime}s`:'重新发送'}}
                </van-button>
            </div>
            <div class="login-back" @click="$router.back()">
                <img src="/static/img/icon_mycenter_back.svg" style="width: 16px;margin-bottom: -3px;" alt="">
                更换手机号
            </div>
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                tel:"",
                code: '',
                code1: '',
                code2: '',
                code3: '',
                code4: '',
                flag: 0,
                restTime: 60,
                error: false,
                disabled: true,

            }
        },
        watch: {
            code (val) {
                if (val) {
                    this.code = val.length > 4 ? val.substr(0, 4) : val;
                    let arr = val.split('');
                    this.code1 = arr[0];
                    this.code2 = arr[1];
                    this.code3 = arr[2];
                    this.code4 = arr[3];
                    if (val.length === 4){
                        Interface.getData('put',Interface.user.update_tel, {
                            mobile: this.tel.replace(/ /g,""),
                            code : this.code,
                        }).then(res => {
                            if (res.code === 0) {
                                this.$toast.success("修改成功")
                                this.$router.push({
                                    name : "my",
                                })
                            }else{
                                this.$toast.fail(res.message)
                            }
                        })
                    }
                }
            }
        },
        methods: {
            startSendOTP () {
                var timer = setInterval(() => {
                    this.restTime--;
                    if (this.restTime <= 0) {
                        this.restTime = 0;
                        this.disabled = false;
                        clearInterval(timer);
                    } else {
                        this.disabled = true;
                    }
                }, 1000);
            },
            sendVerify(){
                let phoneValue = this.tel;
                Interface.getData('get',Interface.user.send_verify, { mobile: phoneValue.replace(/ /g,"") })
                    .then(res => {
                        if (res.code !== -1) {
                            this.restTime = 60
                            this.startSendOTP()
                        }
                    })
            },
            changeCode (e) {
                if (this.code.split('').length <= 1) {
                    this.code = '';
                    this.code1 = '';
                }
                this.$refs.otpInputs.focus();
            },
            confirmCancel () {
                let data = this.OTPdata;
                data['otp'] = `${this.code1}${this.code2}${this.code3}${this.code4}`;
                this.$http.post(applyForRefundTogether, data).then(res => {
                    if (res.code === 200 && res.succ) {
                        this.error = false;
                        Toast('Cancel Successfully');
                    } else {
                        this.error = true;
                        Toast(res.msg);
                    }
                })
            },
            giveUpCancel () {
                this.$emit('giveUpCancel');
            }
        },
        filters: {
            keepSecrect (val) {
                let phone = val.split(' ');
                let head = phone[1].substr(0, 3);
                let tail = phone[1].substr(-3);
                return `${phone[0]} ${head}****${tail}`;
            }
        },
        directives: {
            enterfocus: { // 进入时激活input,可直接输入
                inserted: function (el) {
                    el.focus();
                }
            }
        },
        created() {
            this.tel = this.$route.query.tel
            this.startSendOTP()
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/my-send-verify/index.vue